import React from "react";
import LessonRow from "./LessonRow";
import ChapterHeader from "./ChapterHeader";
import LessonWizard from "./LessonWizard";
import NotebookAddMenu from "./NotebookAddMenu";
import NotebookDeleteModal from "./NotebookDeleteModal";
import NotebookTOC from "./NotebookTOC";
import NotebookEditor from "./NotebookEditor";
import {
    buildNotebookPage,
    groupNotebookPages,
    removeNotebookPage,
    saveNotebookPages,
    updateNotebookPage,
} from "./NotebookUtilities";
const NotebookWorkspace = ({
    notes,
    onNotesChange,

    notebookPages,
    setNotebookPages,

    activeNotebookPageId,
    setActiveNotebookPageId,

    notebookPagesStorageKey,

    isExpanded,
}) => {
    

const [
    expandedChapters,
    setExpandedChapters,
] = React.useState({});

const [
    notebookChapters,
    setNotebookChapters,
] = React.useState([]);

const [
    isChapterWizardOpen,
    setIsChapterWizardOpen,
] = React.useState(false);

const [
    chapterDraftName,
    setChapterDraftName,
] = React.useState("");

const [
    editingPageId,
    setEditingPageId,
] = React.useState(null);

const [
    editingPageTitle,
    setEditingPageTitle,
] = React.useState("");

const [
    editingChapterTitle,
    setEditingChapterTitle,
] = React.useState("");

const [
    editingSectionTitle,
    setEditingSectionTitle,
] = React.useState("");

const [
    pendingDeletePage,
    setPendingDeletePage,
] = React.useState(null);

const [
    isDeleteModalOpen,
    setIsDeleteModalOpen,
] = React.useState(false);

const [
    isAddMenuOpen,
    setIsAddMenuOpen,
] = React.useState(false);

const [
    newPageType,
    setNewPageType,
] = React.useState("lesson");

const [
    isLessonWizardOpen,
    setIsLessonWizardOpen,
] = React.useState(false);

const [
    lessonDraftTitle,
    setLessonDraftTitle,
] = React.useState("");

const [
    lessonDraftChapter,
    setLessonDraftChapter,
] = React.useState("");

const [
    lessonDraftSection,
    setLessonDraftSection,
] = React.useState("");

const [
    lessonDraftNumber,
    setLessonDraftNumber,
] = React.useState("");

const notebookChaptersStorageKey =
    `${notebookPagesStorageKey}_chapters`;
    React.useEffect(() => {
        try {
            const savedChapters =
                JSON.parse(
                    localStorage.getItem(
                        notebookChaptersStorageKey
                    ) || "[]"
                );

            setNotebookChapters(
                Array.isArray(savedChapters)
                    ? savedChapters
                    : []
            );
        } catch (error) {
            console.error(
                "Unable to load notebook chapters:",
                error
            );

            setNotebookChapters([]);
        }
    }, [notebookChaptersStorageKey]);

const saveNotebookChapters = (
    chapters
) => {
    setNotebookChapters(
        chapters
    );

    try {
        localStorage.setItem(
            notebookChaptersStorageKey,
            JSON.stringify(
                chapters
            )
        );
    } catch (error) {
        console.error(
            "Unable to save notebook chapters:",
            error
        );
    }
};
const createNotebookPage = (
    pageType = "lesson"
) => {
    const newPage =
        buildNotebookPage({
            notebookPages,
            pageType,
        });

    const updatedPages = [
        ...notebookPages,
        newPage,
    ];

    setNotebookPages(
        updatedPages
    );

    setActiveNotebookPageId(
        newPage.id
    );

    onNotesChange("");

    saveNotebookPages(
        notebookPagesStorageKey,
        updatedPages,
        "Unable to save notebook page:"
    );
};
    const openNotebookPage = (
        page
    ) => {
        setActiveNotebookPageId(
            page.id
        );

        onNotesChange(
            page.content || ""
        );
    };

    const handlePageContentChange = (
        nextContent
    ) => {
        onNotesChange(nextContent);

        if (!activeNotebookPageId) {
            return;
        }

        const timestamp =
            new Date().toISOString();

        const updatedPages =
            notebookPages.map(
                (page) =>
                    page.id ===
                    activeNotebookPageId
                        ? {
                              ...page,
                              content:
                                  nextContent,
                              updatedAt:
                                  timestamp,
                          }
                        : page
            );

        setNotebookPages(
            updatedPages
        );

        saveNotebookPages(
            notebookPagesStorageKey,
            updatedPages,
            "Unable to save notebook page content:"
        );
    };
const groupedPages =
    groupNotebookPages(
        notebookPages
    );

const chapterNames = Array.from(
    new Set([
        ...notebookChapters,
        ...Object.keys(
            groupedPages
        ).filter(
            (chapterName) =>
                chapterName !==
                "Unassigned"
        ),
    ])
);

const toggleChapter = (chapterName) => {
    setExpandedChapters(
        (currentChapters) => ({
            ...currentChapters,

            [chapterName]:
                currentChapters[
                    chapterName
                ] === false
                    ? true
                    : false,
        })
    );
};

const moveNotebookPage = (
    pageId,
    nextChapterName
) => {
    const cleanChapterName =
        nextChapterName.trim();

    const updatedPages =
        notebookPages.map((page) =>
            page.id === pageId
                ? {
                      ...page,
                      chapterTitle:
                          cleanChapterName,
                      updatedAt:
                          new Date().toISOString(),
                  }
                : page
        );

    setNotebookPages(
        updatedPages
    );

    saveNotebookPages(
        notebookPagesStorageKey,
        updatedPages,
        "Unable to move notebook page:"
    );

    setExpandedChapters(
        (current) => ({
            ...current,
            [cleanChapterName ||
            "Unassigned"]: true,
        })
    );
};

const startEditingPage = (page) => {
    setEditingPageId(page.id);
    setEditingPageTitle(
        page.title || ""
    );
    setEditingChapterTitle(
        page.chapterTitle || ""
    );
    setEditingSectionTitle(
        page.sectionTitle || ""
    );
};

const cancelEditingPage = () => {
    setEditingPageId(null);
    setEditingPageTitle("");
    setEditingChapterTitle("");
    setEditingSectionTitle("");
};

const saveEditingPage = () => {
    if (!editingPageId) {
        return;
    }

    const updatedPages =
        updateNotebookPage({
            notebookPages,
            pageId:
                editingPageId,
            title:
                editingPageTitle,
            chapterTitle:
                editingChapterTitle,
            sectionTitle:
                editingSectionTitle,
        });

    setNotebookPages(
        updatedPages
    );

    saveNotebookPages(
        notebookPagesStorageKey,
        updatedPages,
        "Unable to update notebook page:"
    );

    cancelEditingPage();
};

const deleteNotebookPage = (pageId) => {
    const pageToDelete =
        notebookPages.find(
            (page) =>
                page.id === pageId
        );

    if (!pageToDelete) {
        return;
    }

    setPendingDeletePage(
        pageToDelete
    );

    setIsDeleteModalOpen(
        true
    );
};

const confirmDeleteNotebookPage = () => {
    if (!pendingDeletePage) {
        return;
    }

    const pageId =
        pendingDeletePage.id;

    const updatedPages =
        removeNotebookPage({
            notebookPages,
            pageId,
        });

    setNotebookPages(
        updatedPages
    );

    saveNotebookPages(
        notebookPagesStorageKey,
        updatedPages,
        "Unable to delete notebook page:"
    );

    if (
        activeNotebookPageId ===
        pageId
    ) {
        const nextPage =
            updatedPages[0] || null;

        setActiveNotebookPageId(
            nextPage?.id || null
        );

        onNotesChange(
            nextPage?.content || ""
        );
    }

    if (
        editingPageId ===
        pageId
    ) {
        cancelEditingPage();
    }

    setPendingDeletePage(null);
    setIsDeleteModalOpen(false);
};
const cancelDeleteNotebookPage = () => {
    setPendingDeletePage(null);
    setIsDeleteModalOpen(false);
};
    return (
        <div className="flex h-full min-h-0 flex-col">
            {isDeleteModalOpen && (
                <NotebookDeleteModal
                    pendingDeletePage={
                        pendingDeletePage
                    }
                    onCancel={
                        cancelDeleteNotebookPage
                    }
                    onConfirm={
                        confirmDeleteNotebookPage
                    }
                />
            )}
        <NotebookTOC
            notebookPages={
                notebookPages
            }
            groupedPages={
                groupedPages
            }

            expandedChapters={
                expandedChapters
            }
            setExpandedChapters={
                setExpandedChapters
            }
            toggleChapter={
                toggleChapter
            }

            activeNotebookPageId={
                activeNotebookPageId
            }

            editingPageId={
                editingPageId
            }
            editingPageTitle={
                editingPageTitle
            }
            setEditingPageTitle={
                setEditingPageTitle
            }

            editingChapterTitle={
                editingChapterTitle
            }
            setEditingChapterTitle={
                setEditingChapterTitle
            }

            editingSectionTitle={
                editingSectionTitle
            }
            setEditingSectionTitle={
                setEditingSectionTitle
            }

            openNotebookPage={
                openNotebookPage
            }
            startEditingPage={
                startEditingPage
            }
            saveEditingPage={
                saveEditingPage
            }
            cancelEditingPage={
                cancelEditingPage
            }
            deleteNotebookPage={
                deleteNotebookPage
            }
            chapterNames={
                chapterNames
            }
            moveNotebookPage={
                moveNotebookPage
            }


            notebookPagesStorageKey={
                notebookPagesStorageKey
            }
            setNotebookPages={
                setNotebookPages
            }

            isAddMenuOpen={
                isAddMenuOpen
            }
            setIsAddMenuOpen={
                setIsAddMenuOpen
            }

            setNewPageType={
                setNewPageType
            }

            lessonDraftTitle={
                lessonDraftTitle
            }
            setLessonDraftTitle={
                setLessonDraftTitle
            }

            lessonDraftChapter={
                lessonDraftChapter
            }
            setLessonDraftChapter={
                setLessonDraftChapter
            }

            lessonDraftSection={
                lessonDraftSection
            }
            setLessonDraftSection={
                setLessonDraftSection
            }

            lessonDraftNumber={
                lessonDraftNumber
            }
            setLessonDraftNumber={
                setLessonDraftNumber
            }

            isChapterWizardOpen={
                isChapterWizardOpen
            }
            setIsChapterWizardOpen={
                setIsChapterWizardOpen
            }

            chapterDraftName={
                chapterDraftName
            }
            setChapterDraftName={
                setChapterDraftName
            }

            notebookChapters={
                notebookChapters
            }
            saveNotebookChapters={
                saveNotebookChapters
            }

            isLessonWizardOpen={
                isLessonWizardOpen
            }
            setIsLessonWizardOpen={
                setIsLessonWizardOpen
            }

            createNotebookPage={
                createNotebookPage
            }

            setActiveNotebookPageId={
                setActiveNotebookPageId
            }
            onNotesChange={
                onNotesChange
            }
        />    

           <NotebookEditor
                notes={notes}
                handlePageContentChange={
                    handlePageContentChange
                }
                isExpanded={isExpanded}
            />
               </div>
    );
};

export default NotebookWorkspace;